import { check } from './check';
import { integration } from './integration';
import { integral } from './integral';
import { maxY } from './maxY';
import { maxYPoint } from './maxYPoint';
import { minYPoint } from './minYPoint';
import { reduce } from './reduce';
import { sortX } from './sortX';
import { minClosestYPoint } from './minClosestYPoint';
import { maxClosestYPoint } from './maxClosestYPoint';
import { realMinYPoint } from './realMinYPoint';
import { realMaxYPoint } from './realMaxYPoint';
import { maximaY } from './maximaY';
import { minimaY } from './minimaY';
import { peakInfo } from './peakInfo';

export const XY = {
  check,
  integral,
  integration,
  maxY,
  maximaY,
  maxYPoint,
  minimaY,
  minYPoint,
  reduce,
  sortX,
  minClosestYPoint,
  maxClosestYPoint,
  realMaxYPoint,
  realMinYPoint,
  peakInfo,
};
